'use client';

import * as React from 'react';
import NiceModal from '@ebay/nice-modal-react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

import { AnalyticsProvider } from '@workspace/analytics/hooks/use-analytics';
import { MonitoringProvider } from '@workspace/monitoring/hooks/use-monitoring';
import { TooltipProvider } from '@workspace/ui/components/tooltip';
import { ThemeProvider } from '@workspace/ui/hooks/use-theme';

import { OrganizationLimitsProvider } from '~/hooks/use-organization-limits';

export function Providers({
  children
}: React.PropsWithChildren): React.JSX.Element {
  return (
    <MonitoringProvider>
      <AnalyticsProvider>
        <NuqsAdapter>
          <ThemeProvider
            attribute="class"
            defaultTheme="light"
            enableSystem
            disableTransitionOnChange
          >
            <TooltipProvider>
              {/*
                NiceModal hoists registered modals into this provider's
                placeholder, which lives ABOVE the org-aware
                OrganizationLimitsProvider mounted in
                `/org/[slug]/(organization)/providers.tsx`. Modals like
                UpgradePlanDialog / AddOnsDialog call `useOrganizationLimits`
                in their bodies, so we need a default null-valued provider at
                root to keep the hook from throwing in the hoisted mount.
                The inner provider still overrides this with real limits for
                modals rendered inside the org tree.
              */}
              <OrganizationLimitsProvider limits={null}>
                <NiceModal.Provider>{children}</NiceModal.Provider>
              </OrganizationLimitsProvider>
            </TooltipProvider>
          </ThemeProvider>
        </NuqsAdapter>
      </AnalyticsProvider>
    </MonitoringProvider>
  );
}
